export default __webpack_public_path__ + "static/static-asset-ios-app-42cb8a76147f095d1c7b7dcbe6559c40.svg";